import { render, staticRenderFns } from "./materialView.vue?vue&type=template&id=78f5e270&scoped=true"
import script from "./materialView.vue?vue&type=script&lang=js"
export * from "./materialView.vue?vue&type=script&lang=js"
import style0 from "./materialView.vue?vue&type=style&index=0&id=78f5e270&prod&lang=scss&scoped=true"
import style1 from "./materialView.vue?vue&type=style&index=1&id=78f5e270&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f5e270",
  null
  
)

export default component.exports